import angular from "angular";
import citizenship from "../citizenship";
import core from "../../core/core.module";

angular
    .module('citizenshipsControl.citizenshipForm', [citizenship, core])
    .component('citizenshipForm', {
        template: require('./citizenship-form.html'),
        controller: ['Citizenship', 'notifier', controller],
        bindings: {
            resolve: '<',
            dismiss: '&',
            close: '&'
        }
    });

function controller(Citizenship, notifier) {

    let $ctrl = this;

    $ctrl.$onInit = function () {
        $ctrl.id = null;
        $ctrl.code = null;
        $ctrl.title = null;
        if ($ctrl.resolve.citizenship) {
            let c = $ctrl.resolve.citizenship;
            $ctrl.id = c.id;
            $ctrl.code = c.code;
            $ctrl.title = c.title;
        }
    };

    $ctrl.submit = function () {

        let params = {
            code: $ctrl.code,
            title: $ctrl.title
        };

        let defer = $ctrl.id ? Citizenship.update($ctrl.id, params) : Citizenship.store(params);

        $ctrl.loading = true;

        defer.then(
            function (response) {
                $ctrl.loading = false;
                if (!$ctrl.id) {
                    params.id = response.data.id;
                }
                $ctrl.close({$value: params});
            },
            function (error) {
                $ctrl.loading = false;
                notifier.errorResponseNotify(error);
            }
        );

    };
}

export default 'citizenshipsControl.citizenshipForm';


// WEBPACK FOOTER //
// ./resources/assets/modules/citizenships-control/citizenship-form/citizenship-form.js